import api from '@/apis/ca/cAPaymentAPI.js';
import Crud from '@/stores/crudBase';
import EventBusGlobal from '@/commons/eventBusGlobal';

var crud = new Crud('cAPayment', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ca_payment',
    field: {
      key: 'ref_id',
      code: 'ref_no', //lấy tên cho popup
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,

  /**
   * Ghi đè Cập nhật khi sửa bản ghi ghi sổ
   * lttuan1 9.8.2022
   */
  updateItemPosted(state, payload) {
    // refresh lại bảng badeposit
    EventBusGlobal.$emit('BADeposit/refresh');
    // thực thi hàm của base
    crud.mutations.updateItemPosted(state, payload);
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
